module.exports = __webpack_public_path__ + "f405828a37fda4c47c5fb112f0195f2c.png";